import { useQuery } from '@tanstack/react-query';

import { apiClient } from 'shared/client/apiClient';
import { LearningObjectSnapshot } from 'shared/types/LearningObjects';

export const plenarySnapshotByIdQueryKey = (plenarySnapshotId?: string) =>
  ['plenary-snapshot', { plenarySnapshotId }] as const;

export const getPlenarySnapshotById = async ({ plenarySnapshotId }: { plenarySnapshotId?: string }) => {
  if (!plenarySnapshotId) {
    throw new Error('No `plenarySnapshotId`');
  }

  const { data } = await apiClient.GET('/plenary-snapshots/{plenarySnapshotId}', {
    params: { path: { plenarySnapshotId } }
  });
  return data as any; //FIXME provide return type;
};

export const useGetPlenarySnapshotByIdQuery = (plenarySnapshotId?: string) => {
  return useQuery<LearningObjectSnapshot>({
    queryKey: plenarySnapshotByIdQueryKey(plenarySnapshotId),
    queryFn: () => getPlenarySnapshotById({ plenarySnapshotId }),
    enabled: !!plenarySnapshotId
  });
};
